import i18n from 'i18next';

export const formatCompactNumber = (value: number, options: { isCurrency?: boolean, isPercentage?: boolean, decimals?: number } = {}) => {
  const { isCurrency = false, isPercentage = false, decimals = 2 } = options;
  const isFrench = i18n.language === 'fr';

  if (value === 0) {
    if (isCurrency) {
      return isFrench ? '0,00 $' : '$0.00';
    }
    return '0';
  }

  const absValue = Math.abs(value);
  const sign = value < 0 ? '-' : '';

  let suffix = '';
  let formattedValue = absValue;

  if (absValue >= 1e12) {
    suffix = 'T';
    formattedValue = absValue / 1e12;
  } else if (absValue >= 1e9) {
    suffix = 'B';
    formattedValue = absValue / 1e9;
  } else if (absValue >= 1e6) {
    suffix = 'M';
    formattedValue = absValue / 1e6;
  } else if (absValue >= 1e3) {
    suffix = 'K';
    formattedValue = absValue / 1e3;
  }

  const numStr = formattedValue.toFixed(decimals);
  const localizedNumStr = isFrench ? numStr.replace('.', ',') : numStr;

  if (isCurrency) {
    return isFrench
      ? `${sign}${localizedNumStr}${suffix} $`
      : `${sign}$${localizedNumStr}${suffix}`;
  }

  if (isPercentage) {
    return `${sign}${localizedNumStr}%`;
  }

  return `${sign}${localizedNumStr}${suffix}`;
};

export const generateComparativeValue = (
  currentValue: number | undefined,
  previousValue: number | undefined,
  isCurrency = true,
  isPercentage = false,
  timePeriod = 'from last month',
) => {
  if (currentValue === undefined || previousValue === undefined) {
    return null;
  }

  const change = currentValue - previousValue;
  const percentageChange = previousValue !== 0 ? (change / previousValue) * 100 : 0;
  const isIncrease = change >= 0;

  const formattedValue = formatCompactNumber(currentValue, { isCurrency, isPercentage, decimals: isCurrency ? 2 : 0 });
  const formattedChange = formatCompactNumber(Math.abs(change), { isCurrency, isPercentage, decimals: isCurrency ? 2 : 0 });
  const formattedPercentage = `${Math.abs(percentageChange).toFixed(2)}%`;

  const arrow = isIncrease ? '↑' : '↓';

  return {
    value: formattedValue,
    isIncrease,
    changeText: `${arrow} ${formattedChange} (${formattedPercentage}) ${timePeriod}`,
  };
};
